import each from 'lodash/each'
import { getLanguage } from './utils'

export const routes = {
  en: {
    search_la: '/s/liveaboards/:slug/',
    fleets: '/fleets/:slug/',
    search_dr: '/s/dive-resorts/:slug/',
    la_page: '/liveaboard/:location/:slug/',
    dr_page: '/dive-resort/:location/:slug/',
    destination: '/d/:location/',
    destinations: '/destinations/',
    checkout_la: '/checkout/liveaboard/:location/:slug/',
    checkout_dr: '/checkout/dive-resort/:location/:slug/',
    widget_search_la: '/widget/s/:slug/',
    widget_search_dr: '/widget/s/dr/:slug/',
    group_trips: '/s/group-trips/:slug/',
  },
  fr: {
    search_la: '/fr/s/croisieres-plongee/:slug/',
    fleets: '/fr/flottes/:slug/',
    search_dr: '/fr/s/resorts-plongee/:slug/',
    la_page: '/fr/croisiere-plongee/:location/:slug/',
    dr_page: '/fr/resort-plongee/:location/:slug/',
    destination: '/fr/d/:location/',
    destinations: '/fr/destinations/',
    checkout_la: '/fr/checkout/croisiere-plongee/:location/:slug/',
    checkout_dr: '/fr/checkout/resort-plongee/:location/:slug/',
    widget_search_la: '/fr/widget/s/:slug/',
    widget_search_dr: '/fr/widget/s/dr/:slug/',
    group_trips: '/fr/s/voyages-en-groupe/:slug/',
  },
  es: {
    search_la: '/es/s/cruceros-de-buceo/:slug/',
    fleets: '/es/flotas/:slug/',
    search_dr: '/es/s/resorts-de-buceo/:slug/',
    la_page: '/es/crucero-de-buceo/:location/:slug/',
    dr_page: '/es/resort-de-buceo/:location/:slug/',
    destination: '/es/d/:location/',
    destinations: '/es/destinos/',
    checkout_la: '/es/proceso-de-compra/crucero-de-buceo/:location/:slug/',
    checkout_dr: '/es/proceso-de-compra/resort-de-buceo/:location/:slug/',
    widget_search_la: '/es/widget/s/:slug/',
    widget_search_dr: '/es/widget/s/dr/:slug/',
    group_trips: '/es/s/viajes-en-grupo/:slug/',
  },
  de: {
    search_la: '/de/s/tauchsafaris/:slug/',
    fleets: '/de/flotten/:slug/',
    search_dr: '/de/s/tauchresorts/:slug/',
    la_page: '/de/tauchsafari/:location/:slug/',
    dr_page: '/de/tauchresort/:location/:slug/',
    destination: '/de/d/:location/',
    destinations: '/de/reiseziele/',
    checkout_la: '/de/kasse/tauchsafari/:location/:slug/',
    checkout_dr: '/de/kasse/tauchresort/:location/:slug/',
    widget_search_la: '/de/widget/s/:slug/',
    widget_search_dr: '/de/widget/s/dr/:slug/',
    group_trips: '/de/s/gruppenreisen/:slug/',
  },
  it: {
    search_la: '/it/s/crociere-sub/:slug/',
    fleets: '/it/flotte/:slug/',
    search_dr: '/it/s/viaggi-sub/:slug/',
    la_page: '/it/crociera-sub/:location/:slug/',
    dr_page: '/it/viaggio-sub/:location/:slug/',
    destination: '/it/d/:location/',
    destinations: '/it/destinazioni/',
    checkout_la: '/it/checkout/crociera-sub/:location/:slug/',
    checkout_dr: '/it/checkout/viaggio-sub/:location/:slug/',
    widget_search_la: '/it/widget/s/:slug/',
    widget_search_dr: '/it/widget/s/dr/:slug/',
    group_trips: '/de/s/viaggi-di-gruppo/:slug/',
  },
}

export const APP_LANGUAGE = getLanguage()

export function createFullUrl(path, language) {
  let lang = language || APP_LANGUAGE

  if(!routes[lang]) {
    lang = 'en'
  }

  return routes[lang][path]
}

export function createUrl(path, params, query) {
  let url = createFullUrl(path)

  if(params) {
    each(params, function(val, key) {
      url = url.replace(':' + key, val)
    })
  }

  if(query) {
    if(url[url.length - 1] === '/') {
      url = url.slice(0, -1) + query
    } else {
      url += query
    }
  }

  return url
}
